import Vue from 'vue'
export const FieldEventBus = new Vue()
